'use client'

import { useEffect } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'

/** Forwards `/` to `/san-pham`, preserving the query string the tenant arrives in. */
export default function RootRedirect() {
  const router = useRouter()
  const searchParams = useSearchParams()

  useEffect(() => {
    const query = searchParams.toString()
    router.replace(query ? `/san-pham?${query}` : '/san-pham')
  }, [router, searchParams])

  return null
}
